import { classExists } from "./helper/class-exists";
import { clickButton } from "./helper/click-button";

const decodeBase64 = (base64) => {
  const text = atob(base64);
  const length = text.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    bytes[i] = text.charCodeAt(i);
  }
  const decoder = new TextDecoder(); // default is utf-8
  return decoder.decode(bytes);
};

const modalCloseHandler = (modal, backdrop, body) => {
  modal.classList.remove("is-animate");
  backdrop.classList.remove("is-animate");

  setTimeout(() => {
    modal.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    body.classList.remove("modal-open");
  }, 300);
};

const awardHandler = (modal) => {
  if (modal.classList.contains("is-awards")) {
    if (modal.querySelector("iframe")) {
      modal.querySelector("iframe").remove();
      const iframeEl = document.createElement("iframe");
      iframeEl.classList.add("iframe-youtube");
      iframeEl.src = "";
      iframeEl.setAttribute("frameborder", "0");
      iframeEl.setAttribute("allow", "autoplay; encrypted-media");
      iframeEl.setAttribute("loading", "lazy");
      iframeEl.setAttribute("allowfullscreen", "");

      modal.querySelector(".iframe-container").classList.add("not-playing");
      modal.querySelector(".iframe-container").appendChild(iframeEl);
    }
  }
};

const modalButton = () => {
  const buttons = document.querySelectorAll(".js-modal-button");
  const modalBackdrop = document.querySelector(".modal-backdrop");
  const bodyElem = document.querySelector("body");
  const modals = document.querySelectorAll(".js-modal-item");

  buttons.forEach((button) => {
    const targetModal = button.dataset.modalTarget;

    button.addEventListener("click", function (event) {
      event.preventDefault();
      const modal = document.querySelector("#" + targetModal);
      if (!modal) {
        console.log("Modal element not found");
        return false;
      }

      if (button.classList.contains("change-source")) {
        const imageSrc = button.querySelector(".image img").src;

        const modalImageSrc = modal.querySelector(".image-source");

        modalImageSrc.setAttribute("src", imageSrc);
        // img.setAttribute('src', 'images/new-image.jpg');
      }

      bodyElem.classList.add("modal-open");
      modal.classList.add("is-open");
      modalBackdrop.classList.add("is-open");

      setTimeout(() => {
        modal.classList.add("is-animate");
        modalBackdrop.classList.add("is-animate");
      }, 300);

      let thisButton = this;
      if (thisButton.classList.contains("is-commercial-page-award-logo")) {
        let awardName = thisButton.dataset.awardName;
        let awardSummary = decodeBase64(thisButton.dataset.listSummary);
        document.querySelector(".modal-award-name").innerHTML = awardName;
        document.querySelector(".modal-award-summary").innerHTML = awardSummary;
      }
    });
  });

  modals.forEach((modal) => {
    const button = modal.querySelector(".close-button");

    button.addEventListener("click", function (event) {
      event.preventDefault();
      modalCloseHandler(modal, modalBackdrop, bodyElem);
      awardHandler(modal);
    });

    const buttonOkay = modal.querySelector(".js-close-okay");

    if (buttonOkay) {
      buttonOkay.addEventListener("click", function (event) {
        event.preventDefault();
        button.click();
      });
    }
  });

  document.addEventListener("click", (event) => {
    modals.forEach((modal) => {
      const boolIsOutside = modal.isSameNode(event.target);

      if (boolIsOutside) {
        modalCloseHandler(modal, modalBackdrop, bodyElem);
        awardHandler(modal);
      }
    });
  });
};

const modalButtonImage = () => {
  const buttons = document.querySelectorAll(".image-modal-button");
  const modalBackdrop = document.querySelector(".modal-backdrop");
  const bodyElem = document.querySelector("body");
  const modal = document.querySelector(".image-modal-item");

  if (buttons.length === 0 && modal.length > 0) {
    modal.remove();
    return;
  }

  if (buttons.length === 0) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      bodyElem.classList.add("modal-open");
      modal.classList.add("is-open");
      modalBackdrop.classList.add("is-open");

      setTimeout(() => {
        modal.classList.add("is-animate");
        modalBackdrop.classList.add("is-animate");

        modal.querySelector(".image-full").innerHTML = "";
        const imgElement = document.createElement("img");
        imgElement.src = button.src;

        imgElement.alt = "Description of the image";
        modal.querySelector(".image-full").appendChild(imgElement);
      }, 300);
    });
  });

  const closeBtn = modal.querySelector(".close-button");

  closeBtn.addEventListener("click", function (event) {
    event.preventDefault();
    modalCloseHandler(modal, modalBackdrop, bodyElem);
  });

  document.addEventListener("click", (event) => {
    const boolIsOutside = modal.isSameNode(event.target);

    if (boolIsOutside) {
      modalCloseHandler(modal, modalBackdrop, bodyElem);
    }
  });
};

const toolTipClick = (elem, windowMedia) => {
  if (windowMedia.matches) {
    return;
  }

  const tooltipInfos = document.querySelectorAll(".tooltip-info");

  tooltipInfos.forEach((tooltipInfo) => {
    if (tooltipInfo !== elem) {
      tooltipInfo.classList.remove("is-open");
    }
  });

  const commercialInfos = document.querySelectorAll(".editor-info");
  if (commercialInfos.length) {
    [...commercialInfos].map((commercialInfo) =>
      commercialInfo.classList.remove("is-open")
    );
  }
  elem.classList.toggle("is-open");
};

const toolTipHover = (buttons, elem, windowMedia) => {
  setTimeout(() => {
    if (!windowMedia.matches) {
      return;
    }

    if (
      ![...buttons].some((button) => button.matches(":hover")) &&
      !elem.matches(":hover")
    ) {
      elem.classList.remove("is-open");
    }
  }, 200);
};

const toolTipClose = (windowMedia) => {
  if (windowMedia.matches) {
    return;
  }

  const tooltipInfos = document.querySelectorAll(".tooltip-info");

  tooltipInfos.forEach((tooltipInfo) => {
    tooltipInfo.classList.remove("is-open");
  });
};

const toolTip = () => {
  const buttons = document.querySelectorAll(".js-tooltip-button");
  classExists(buttons);

  const windowMedia = window.matchMedia("(min-width: 1024px)");

  const toolTopinfos = document.querySelectorAll('.tooltip-info');

  buttons.forEach((button) => {
    const elem = button.nextElementSibling;

    button.addEventListener("mouseover", () => {
      if (windowMedia.matches) {
        toolTopinfos.forEach((tooltipInfo) => tooltipInfo.classList.remove('is-open'));
        elem.classList.add("is-open");
      }
    });

    button.addEventListener("mouseout", () => {

      toolTipHover(buttons, elem, windowMedia);
    });
    button.addEventListener("mouseleave", () =>
      toolTipHover(buttons, elem, windowMedia)
    );
    elem.addEventListener("mouseleave", () =>
      toolTipHover(buttons, elem, windowMedia)
    );

    clickButton([button], () => toolTipClick(elem, windowMedia));
  });

  const closeButtons = document.querySelectorAll(".close-tooltip");
  clickButton(closeButtons, () => toolTipClose(windowMedia));
  toolTipOutside();
};

const toolTipOutside = () => {
  document.addEventListener("click", (event) => {
    const toolTipInfos = document.querySelectorAll(".tooltip-info");

    const isInside = event.target.closest(".tooltip-info");
    const button = event.target.closest(".js-tooltip-button");
    const commercialButton = event.target.closest(".js-commercial-btn");
    const authorButton = event.target.closest(".js-commercial-author-btn");

    if (!isInside && !button && !commercialButton && !authorButton) {
      toolTipInfos.forEach((tooltip) => {
        tooltip.classList.remove("is-open");
      });
    }
  });
};

const toolTipResize = () => {
  const toolTips = document.querySelectorAll(".tooltip-info");
  classExists(toolTips);

  toolTips.forEach((toolTip) => toolTip.classList.remove("is-open"));
};

document.addEventListener("DOMContentLoaded", function () {
  modalButton();
  modalButtonImage();
  toolTip();
});

window.addEventListener(
  "resize",
  (event) => {
    toolTipResize();
  },
  true
);
